import React from 'react';
import { TextInput } from 'react-admin';

import Edit from '../common/views/Edit';
import SimpleForm from '../common/forms/SimpleForm';
import CountryInput from '../common/inputs/CountryInput';


const CompanyEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="id" disabled />
            <TextInput source="name" />
            <CountryInput source="country" />
            <TextInput source="street" />
            <TextInput source="zipcode" />
            <TextInput source="city" />
            <TextInput source="vat_number" />
            <TextInput source="bank_name" />
            <TextInput source="bank_bic" />
            <TextInput source="bank_iban" />
            <TextInput source="email" />
            <TextInput source="website" />
            <TextInput source="phone" />
        </SimpleForm>
    </Edit>
);

export default CompanyEdit;